import React, { useEffect, useState } from "react";
import { ProgressBar, Container, Row, Col } from "react-bootstrap";

const Loader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 95) return prev;
        return prev + Math.floor(Math.random() * 5) + 1;
      });
    }, 200);

    return () => clearInterval(timer);
  }, []);

  return (
    <Container className="text-center mt-5">
      <Row>
        <Col>
          <h4>Loading... {progress}%</h4>
          <ProgressBar now={progress} animated striped />
        </Col>
      </Row>
    </Container>
  );
};

export default Loader;
